import React, { useState } from "react";
import { StyleSheet, View, Platform } from "react-native";
import AppMessages from "../../../../config/AppMessages";
import { openURL } from "../../../../helpers/utils";
import AppTheme from "../../AppTheme";

import { buttonStyle } from "../../common/ActionsMenuButton/utils";
import ActionButton from "../../common/ActionsMenuButton/ActionButton";
import EditElementsIcon from "../../common/ActionsMenuButton/icons/EditElementsIcon";
import OperationIcon from "../../common/ActionsMenuButton/icons/OperationIcon";
import InviteIcon from '../../common/ActionsMenuButton/icons/InviteIcon';

export default function LastWeekFabButton({
  undoChanges,
  goToElementsPage,
  fitHours,
  mariOptions,
  weeklyHours,
  style,
}) {
  const [actionButton, setActionButton] = useState(null);

  const fitButtonTitle = "Fit to " + weeklyHours + " Hours";

  return (
    <View
      style={[
        buttonStyle,
        style,
        mariOptions.mariMessage ? { zIndex: 1000 } : {},
      ]}
      onLayout={(event) => {
        if (actionButton != null)
          actionButton.setParentLayout(event.nativeEvent.layout);
      }}
    >
      <ActionButton
        mariOptions={mariOptions}
        ref={(r) => setActionButton(r)}
        buttonColor={AppTheme.DEFAULT_COLOR}
        zIndex={999}
        source={"LastWeekFabButton"}
        buttonTextStyle={styles.mainButton}
      >
        <ActionButton.Item
          noBorder
          underline
          hideShadow
          buttonColor="#FFF"
          title="Help"
          onPress={() => {
            openURL(AppMessages.SupportEmail);
          }}
        >
          <InviteIcon style={styles.actionButtonIcon} />
        </ActionButton.Item>

        <ActionButton.Item
          noBorder
          hideShadow
          buttonColor="#FFF"
          title="Undo All Manual Changes"
          onPress={undoChanges}
        >
          <OperationIcon style={styles.actionButtonIcon} />
        </ActionButton.Item>

        <ActionButton.Item
          noBorder
          hideShadow
          buttonColor="#FFF"
          title={fitButtonTitle}
          onPress={() => fitHours()}
        >
          <OperationIcon style={styles.actionButtonIcon} />
        </ActionButton.Item>

        <ActionButton.Item
          noBorder
          hideShadow
          buttonColor="#FFF"
          title="Set as Uncategorized"
          onPress={() => fitHours(true)}
        >
          <OperationIcon style={styles.actionButtonIcon} />
        </ActionButton.Item>

        <ActionButton.Item
          isSelected={mariOptions.tutorialStep == 6}
          noBorder
          hideShadow
          buttonColor="#FFF"
          title="Edit Elements"
          onPress={goToElementsPage}
        >
          <EditElementsIcon style={styles.actionButtonIcon} />
        </ActionButton.Item>
      </ActionButton>
    </View>
  );
}

const styles = StyleSheet.create({
  mainButton: {
    fontSize: 44,
    height: 58,
    marginTop: -5,
    fontWeight: "200",
    fontFamily:  Platform.select({ default: "Nunito", android: "Nunito-Regular" }),
  },
  actionButtonIcon: {
    marginTop: 5,
    width: 44,
    height: 44,
  },
});
